/**
 * Banner Products Grid Section
 * 处理产品网格的动态高度调整和滚动行为
 */

class BannerProductsGrid {
  constructor(section) {
    this.section = section;
    this.productsGrid = section.querySelector('.products-grid');
    this.bannerBlock = section.querySelector('.banner-block');
    this.productCount = this.productsGrid ? parseInt(this.productsGrid.dataset.productCount) : 0;
    
    this.init();
  }

  init() {
    if (!this.productsGrid || !this.bannerBlock) return;

    // 等待图片加载完成后调整高度
    this.waitForImages().then(() => {
      this.adjustGridHeight();
    });

    // 监听窗口大小变化
    window.addEventListener('resize', this.debounce(() => {
      this.adjustGridHeight();
    }, 250));

    // 如果有滚动，添加平滑滚动
    if (this.productCount > 4) {
      this.enableSmoothScroll();
    }
  }

  /**
   * 等待所有图片加载完成
   */
  waitForImages() {
    const images = this.section.querySelectorAll('img');
    const imagePromises = Array.from(images).map(img => {
      return new Promise((resolve) => {
        if (img.complete) {
          resolve();
        } else {
          img.addEventListener('load', resolve);
          img.addEventListener('error', resolve);
        }
      });
    });

    return Promise.all(imagePromises);
  }

  /**
   * 调整产品网格高度以匹配banner高度
   */
  adjustGridHeight() {
    // 移动端不需要调整
    if (window.innerWidth <= 768) {
      this.productsGrid.style.maxHeight = '';
      return;
    }

    const bannerHeight = this.bannerBlock.offsetHeight;
    
    if (this.productCount > 4) {
      // 超过4个产品时，设置最大高度为banner高度
      this.productsGrid.style.maxHeight = `${bannerHeight}px`;
    } else {
      // 4个或更少产品时，移除最大高度限制
      this.productsGrid.style.maxHeight = '';
    }
  }

  /**
   * 启用平滑滚动
   */
  enableSmoothScroll() {
    if (!this.productsGrid) return;

    // 为触摸设备添加惯性滚动
    this.productsGrid.style.webkitOverflowScrolling = 'touch';
    
    // 添加滚动指示器（可选）
    this.addScrollIndicator();
  }

  /**
   * 添加滚动指示器
   */
  addScrollIndicator() {
    const indicator = document.createElement('div');
    indicator.className = 'scroll-indicator';
    indicator.innerHTML = '↓';
    indicator.style.cssText = `
      position: absolute;
      bottom: 10px;
      right: 20px;
      background: rgba(0, 0, 0, 0.5);
      color: white;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
      z-index: 10;
    `;

    this.productsGrid.parentElement.style.position = 'relative';
    this.productsGrid.parentElement.appendChild(indicator);

    // 监听滚动，控制指示器显示
    let scrollTimeout;
    this.productsGrid.addEventListener('scroll', () => {
      const { scrollTop, scrollHeight, clientHeight } = this.productsGrid;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 50;

      if (!isNearBottom && scrollTop < scrollHeight - clientHeight - 10) {
        indicator.style.opacity = '1';
      } else {
        indicator.style.opacity = '0';
      }

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        indicator.style.opacity = '0';
      }, 2000);
    });

    // 初始显示指示器
    setTimeout(() => {
      if (this.productsGrid.scrollHeight > this.productsGrid.clientHeight) {
        indicator.style.opacity = '1';
        setTimeout(() => {
          indicator.style.opacity = '0';
        }, 3000);
      }
    }, 500);
  }

  /**
   * 防抖函数
   */
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// 初始化所有section
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.banner-products-section');
  sections.forEach(section => {
    new BannerProductsGrid(section);
  });
});

// Shopify Theme Editor支持
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.banner-products-section');
    if (section) {
      new BannerProductsGrid(section);
    }
  });

  document.addEventListener('shopify:section:reorder', () => {
    const sections = document.querySelectorAll('.banner-products-section');
    sections.forEach(section => {
      new BannerProductsGrid(section);
    });
  });
}